import actionTypes from '../actionTypes'

const iVideoCreationMcqActions = {
	createNewMcqActivitySuccess: (activityUid, breakpointActivityUid, answersUids) => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_CREATE_SUCCESS,
		activityUid,
		breakpointActivityUid,
		answersUids,
	}),
	createNewMcqActivityError: activity => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_CREATE_ERROR,
		activity,
	}),
	save: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE,
	}),
	saveSuccess: isEdition => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_SUCCESS,
		isEdition,
	}),
	saveFailed: error => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_ERROR,
		error,
	}),
	answerFocus: answerId => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_ANSWER_FOCUS,
		answerId,
	}),
	questionFocus: () => ({
		type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_QUESTION_FOCUS,
	}),
}

export default iVideoCreationMcqActions
